import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/comensal-3-dividir.webp")